/**
 * Extracts the creation timestamp from a MongoDB ObjectId
 * @param {string} objectId - The MongoDB ObjectId string
 * @returns {Date|null} - The creation date or null if invalid
 */
const getObjectIdTimestamp = (objectId) => {
  if (!objectId || typeof objectId !== 'string' || objectId.length !== 24) {
    return null;
  }
  
  try {
    // Extract the first 8 characters (4 bytes) which represent the timestamp
    const timestampHex = objectId.substring(0, 8);
    const timestamp = parseInt(timestampHex, 16);
    
    // Convert to milliseconds (MongoDB timestamps are in seconds)
    const date = new Date(timestamp * 1000);
    
    return date;
  } catch (error) {
    console.error('Error extracting timestamp from ObjectId:', error);
    return null;
  }
};

export default getObjectIdTimestamp; 